import $ from 'jquery';
import moment from 'moment';

const NL_ADDRESS_STORAGE_PREFIX = 'abc_checkout_nl_';

function readNlAddress(prefix) {
  try {
    const raw = sessionStorage.getItem(NL_ADDRESS_STORAGE_PREFIX + prefix);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function persistNlAddress(prefix) {
  const data = {
    street: $(`#${prefix}street_name`).val() || '',
    number: $(`#${prefix}house_number`).val() || '',
    suffix: $(`#${prefix}house_number_suffix`).val() || '',
    city: $(`#${prefix}city`).val() || '',
    postcode: $(`#${prefix}postcode`).val() || '',
    address1: $(`#${prefix}address_1`).val() || '',
  };

  if (!data.street && !data.address1) {
    return;
  }

  try {
    sessionStorage.setItem(NL_ADDRESS_STORAGE_PREFIX + prefix, JSON.stringify(data));
  } catch (e) {
    // Ignore quota / private mode errors.
  }
}

/**
 * Restore street_name when postcode checker autofill was lost after reload.
 * Prefers sessionStorage, then falls back to parsing address_1.
 */
function restoreNlStreetFields(prefix) {
  const $street = $(`#${prefix}street_name`);
  if (!$street.length || $street.val()) {
    return;
  }

  const stored = readNlAddress(prefix);
  if (stored && stored.street) {
    $street.val(stored.street);
    if (stored.city && !$(`#${prefix}city`).val()) {
      $(`#${prefix}city`).val(stored.city);
    }
    if (stored.address1 && !$(`#${prefix}address_1`).val()) {
      $(`#${prefix}address_1`).val(stored.address1);
    }
    if (stored.number && !$(`#${prefix}house_number`).val()) {
      $(`#${prefix}house_number`).val(stored.number);
    }
    if (stored.suffix && !$(`#${prefix}house_number_suffix`).val()) {
      $(`#${prefix}house_number_suffix`).val(stored.suffix);
    }
    return;
  }

  const address1 = $(`#${prefix}address_1`).val();
  if (!address1) {
    return;
  }

  const number = String($(`#${prefix}house_number`).val() || '').trim();
  const suffix = String($(`#${prefix}house_number_suffix`).val() || '').trim();
  let street = address1;

  if (number) {
    const trailing = suffix ? `${number}-${suffix}` : number;
    if (street.endsWith(trailing)) {
      street = street.slice(0, -trailing.length).trim();
    } else if (street.endsWith(number)) {
      street = street.slice(0, -number.length).trim();
    }
  } else {
    const match = address1.match(/^(.*?)\s+(\d+[a-zA-Z]?)(?:-(\S+))?$/);
    if (match) {
      street = match[1];
    }
  }

  if (street && street !== address1) {
    $street.val(street);
  }
}

function restoreAllNlStreetFields() {
  restoreNlStreetFields('billing_');
  restoreNlStreetFields('shipping_');
}

function persistAllNlAddresses() {
  persistNlAddress('billing_');
  persistNlAddress('shipping_');
}

export default {
  init() {
    $(function () {
      restoreAllNlStreetFields();
      $(document.body).on('updated_checkout', restoreAllNlStreetFields);
      $('body').on('wpo_wcnlpc_fields_updated', persistAllNlAddresses);

      let deliveryTime = $('#delivery_time').eq(0);
      let deliveryTimes = deliveryTime.data('delivery-times');

      for (let times in deliveryTimes) {
        for (let time in deliveryTimes[times]) {
          deliveryTimes[times][time] = new moment(deliveryTimes[times][time], 'HH:mm');
        }
      }

      let deliveryDate = $('#delivery_date').eq(0);
      let openingTimes = deliveryDate.data('opening-times');
      let daysOfWeekDisabled = [];


      for (let i in openingTimes) {
        if (! openingTimes[i][0] || ! openingTimes[i][1]) daysOfWeekDisabled.push(i);
      }

      for (let times in openingTimes) {
        for (let time in openingTimes[times]) {
          openingTimes[times][time] = new moment(openingTimes[times][time], 'HH:mm');
        }
      }

      deliveryDate.datepicker({
        language: 'nl',
        daysOfWeekDisabled,
        format: 'dd-mm-yyyy',
        startDate: new moment().format('DD-MM-YYYY'),
        endDate: new moment().add(deliveryDate.data('max-delivery-days'), 'days').format('DD-MM-YYYY'),
      });

      deliveryDate.on('change', function (event) {
        let t = $(this);
        let openingTimes = t.data('opening-times');
        let deliveryTime = $('#delivery_time');
        let deliveryTimes = deliveryTime.data('delivery-times');
        let date = new moment(event.target.value, 'DD-MM-YYYY');

        let weekDay = date.day();

        deliveryTime.empty();

        for (let i in deliveryTimes) {
          if (
            deliveryTimes[i][0].isSameOrAfter(openingTimes[weekDay][0]) &&
            deliveryTimes[i][1].isSameOrBefore(openingTimes[weekDay][1])
          ) {
            let currentDate = new moment();
            let deliveryDateMoment = new moment(deliveryDate.val() + ' ' + deliveryTimes[i][0].format('HH:mm'), 'DD-MM-YYYY HH:mm');
            if (deliveryDateMoment.subtract(deliveryDate.data('hours-before-delivery'), 'hours').isSameOrAfter(currentDate)) {
                let time = `${deliveryTimes[i][0].format('H:mm')}-${deliveryTimes[i][1].format('H:mm')}`;
                $('<option></option>').val(time).html(time).appendTo(deliveryTime);
            }
          }
        }
      });
    });
  },
  finalize() {

  },
};
